import type { ResearchCitation, StrategyDetail, StrategyPanel, StrategyText } from './strategy_types'

function panelFromText({ text }: StrategyText): StrategyPanel {
  const firstLineEnd = text.indexOf('\n')
  if (firstLineEnd === -1) {
    return { title: text, text: '' }
  }
  return {
    title: text.slice(0, firstLineEnd),
    text: text.slice(firstLineEnd)
  }
}

/** The sections every strategy page (detail, saved, shared) renders from one strategy. */
export function strategyPageSections(strategy: StrategyDetail, verifiedLibraryGoal: boolean) {
  const relatedStrategies = (strategy.related_adaptations ?? []).filter((related) => related.published)
  const researchCitations: ResearchCitation[] = strategy.research_citations ?? []

  return {
    banner: {
      uuid: strategy.uuid,
      title: strategy.title,
      altNames: strategy.alt_names,
      description: strategy.description,
      udlStandards: strategy.udl_standards,
      imageUrl: strategy.image_url
    },
    resources: {
      resources: strategy.resources
    },
    implementation: {
      title: 'Implementation Tips',
      panelData: strategy.tips.map(panelFromText),
      overwriteBlur: verifiedLibraryGoal
    },
    examples: {
      title: 'Examples',
      panelData: strategy.examples.map(panelFromText),
      overwriteBlur: verifiedLibraryGoal
    },
    researchCitations: researchCitations.length ? researchCitations : null,
    related: relatedStrategies.length ? { relatedStrategies } : null
  }
}
